import pc from 'picocolors';
import { ApiClient } from '../client.js';
import { resolveProfile } from '../profiles.js';
import { emitJson, fail, human, type Io } from '../output.js';
import { DEFAULT_PRODUCT_NAME } from '../constants.js';

interface MeResponse {
  email: string;
  apps: string[];
  githubUsername: string | null;
  branding?: { productName?: string };
}

export async function runWhoami(options: { adminUrl?: string; json?: boolean }): Promise<void> {
  const io: Io = { json: options.json === true, productName: DEFAULT_PRODUCT_NAME };
  const resolved = resolveProfile(options.adminUrl);
  if (!resolved) {
    fail(io, 'Not signed in. Run `ghosty login` first.', 1, 'NOT_LOGGED_IN');
  }
  io.productName = resolved.profile.branding?.productName ?? DEFAULT_PRODUCT_NAME;

  const client = new ApiClient(resolved.adminUrl, resolved.profile.token);
  let me: MeResponse;
  try {
    me = await client.get<MeResponse>('/builder-api/me');
  } catch (err) {
    fail(io, (err as Error).message, 1, 'API_ERROR');
  }

  if (io.json) {
    emitJson({ ok: true, adminUrl: resolved.adminUrl, ...me });
    return;
  }
  human(io, `${pc.bold(me.email)} on ${pc.bold(me.branding?.productName ?? io.productName)} (${resolved.adminUrl})`);
  human(io, `  GitHub: ${me.githubUsername ?? pc.dim('not set — run `ghosty profile --github <username>`')}`);
  human(io, `  Apps:   ${me.apps.length > 0 ? me.apps.join(', ') : pc.dim('none yet')}`);
}
